import { Publisher } from '@/model';
import api from '@/rest-api';
import { uniqueIndex } from '@/util/array-util';
import Vue from 'vue';

const publishersSorter = (a: Publisher, b: Publisher) => a.name.trim().localeCompare(b.name.trim());

function createStore() {
  const state = Vue.observable({
    publishers: [] as readonly Publisher[],
  });
  function index() {
    return uniqueIndex(state.publishers || [], (l) => l.id);
  }
  const getters = Vue.observable({
    lookup: index(),
  });
  const commit = {
    setPublisher(ps: Publisher[]) {
      state.publishers = ps.sort(publishersSorter);
      getters.lookup = index();
    },
    publisherChange(publisher: Publisher) {
      const ps = [...state.publishers.filter((p) => p.id !== publisher.id), publisher];
      state.publishers = ps.sort(publishersSorter);
      getters.lookup = index();
    },
  };
  const dispatch = {
    async all(): Promise<readonly Publisher[]> {
      if (state.publishers.length > 0) {
        return state.publishers;
      }
      const ps = await api.publishers();
      commit.setPublisher(ps);
      return ps;
    },
    async save(publisher: Partial<Publisher>): Promise<Publisher> {
      const saved = await api.savePublisher(publisher);
      commit.publisherChange(saved);
      return saved;
    },
  };
  return {
    state, getters, dispatch,
  };
}

const publishers = createStore();
export default publishers;
